module.exports = __webpack_public_path__ + "img/YX.f68a6300.png";